/**
 * Verify that the password has the minimal length
 * @param password Password to verify
 * @param minLength Minimal length of the given password
 * @returns 
 */
export function hasMinimalLength(password: string, minLength: number): boolean {
    return password.length >= minLength;
}

/**
 * Verify that the password has the minimal uppercase amount
 * @param password Passwords to verify
 * @param minUppercase Minimal uppercase amount
 * @returns 
 */
export function hasMinimalUppercase(password: string, minUppercase: number): boolean {
    return (password.match(/[A-Z]/g) ?? []).length >= minUppercase;
}

/**
 * Verify that the password has the minimal lowercase amount
 * @param password Passwords to verify
 * @param minLowercase Minimal lowercase amount
 * @returns 
 */
export function hasMinimalLowercase(password: string, minLowercase: number): boolean {
    return (password.match(/[a-z]/g) ?? []).length >= minLowercase;
}

/**
 * Verify that the password has the minimal special characters amount
 * see https://stackoverflow.com/questions/32311081/check-for-special-characters-in-string
 * @param password Passwords to verify
 * @param minSpecialCharacters Minimal special characters amount
 * @returns 
 */
export function hasMinimalSpecialCharacters(password: string, minSpecialCharacters: number): boolean {
    return (password.match(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/g) ?? []).length >= minSpecialCharacters;
}

/**
 * Verify that the password has the minimal number amount
 * @param password Passwords to verify
 * @param minNumbers Minimal number amount
 * @returns 
 */
export function hasMinimalNumbers(password: string, minNumbers: number): boolean {
    return (password.match(/[0-9]/g) ?? []).length >= minNumbers;
}